<template>
  <nav ref="categoriesList" class="outer__categories--container no-scrollbar w-full rounded-[0_0_1.25rem_1.25rem]">
    <!-- temporary category-item text measurer -->
    <div
        id="temp-text-measurer"
        class="absolute opacity-0 z-[-1] px-2 md:px-2.5 font-bold py-3 w-max inline-block overflow-hidden text-[13px] lg:text-[14px] 3xl:text-[16px]"
    ></div>

    <ul
        v-if="isLoading"
        id="categoriesList"
        class="flex list-none relative categories mx-0 gap-1 flex-nowrap text-[#000000] text-[15px] sm:text-[16px] font-bold z-9"
    >
      <li
          :class="`item main--category--item text-center relative cursor-pointer text-ellipsis category-item capitalize transition-colors duration-200 bg-inherit hover:bg-primary hover:text-white`.trim()">

        <NuxtLink disabled
                  class="opacity-0 flex items-center px-2 md:px-2.5 py-4 w-full h-full max-h-[56px] overflow-hidden text-[13px] lg:text-[14px] 3xl:text-[16px] text-ellipsis whitespace-nowrap">
          Cezma</NuxtLink>
      </li>
    </ul>
    <!-- shows when loaded -->
    <ul
        v-if="!isLoading"
        id="categoriesList"
        class="flex list-none relative categories mx-0 gap-1 flex-nowrap text-[#000000] text-[15px] sm:text-[16px] font-bold z-9"
    >
      <HomeCategoryItem
          v-for="(category, index) in itemsToShow"
          :id="category.id"
          :key="category.id || index"
          :index="index"
          :item="category"
          :length="itemsToShow.length"
      />
    </ul>
    <!-- <div v-else>{{ $t("general.empty_categories") }}</div> -->
  </nav>
</template>

<script>
import HomeCategoryItem from "./MainCategoryItem.vue";
import {debounceFunc} from '@/helpers';

export default {
  data() {
    return {
      itemsToShow: [],
      moreToShow: [],
      itemsCount: 10
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    },
    categoriesList: {
      type: Array,
      required: true,
      default: () => ([])
    },
    savedCategoriesLength: {
      type: Number,
      required: true,
      default: 0
    },
    listLength: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    HomeCategoryItem
  },
  methods: {
    updateItemsVisibility() {
      this.$nextTick(() => {
        const container = document.getElementById("categoriesList");
        if (!container) {
          return;
        }

        function calculateTextWidth(text) {
          const textMeasurer = document.getElementById("temp-text-measurer");
          textMeasurer.textContent = text;
          return textMeasurer.offsetWidth;
        }

        const containerWidth = container.getBoundingClientRect()?.width;
        let visibleItems = [];
        let tempContainerFullWidth = 0;
        let areItemsOverflowing = false;
        for (let i = 0; i < this.categoriesList.length; i++) {
          const item = this.categoriesList[i];
          const itemWidth = calculateTextWidth(item[this.nameKey]);
          if (tempContainerFullWidth + itemWidth <= containerWidth) {
            visibleItems.push(item);
          } else {
            areItemsOverflowing = true;
            break;
          }
          tempContainerFullWidth += itemWidth;
        }
        this.itemsToShow = areItemsOverflowing
            ? [
              ...visibleItems.slice(0, visibleItems?.length - 1),
              {
                id: "more",
                name_en: "More",
                name_ar: "المزيد",
                link: this.ROUTESNAMES.user.categories
              }
            ]
            : visibleItems;
      });
    },
    callUpdateItemsVisibilityWithDebounce() {
      debounceFunc(() => {
        // calls the function one time only
        this.updateItemsVisibility();
      }, 0)()
    }
  },
  mounted() {
    this.callUpdateItemsVisibilityWithDebounce();
    if (process.client) {
      // TODO: replace this resize event listener with a media query listener to enhance the performance
      window.addEventListener("resize", this.updateItemsVisibility);
    }
  },
  watch: {
    listLength(val) {
      if (val > 0) {
        this.itemsToShow = this.categoriesList;
        this.callUpdateItemsVisibilityWithDebounce();
      }
    },
    currentlySelectedLanguage(lang) {
      if (typeof lang === "string" && lang) {
        setTimeout(() => {
          this.callUpdateItemsVisibilityWithDebounce();
        }, 100);
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateItemsVisibility);
  }
};
</script>

<style lang="scss" scoped>
</style>